<template>
	<div>
		<el-drawer title="演出推广" :visible.sync="drawerShow" :wrapperClosable="true" :destroy-on-close="true" size="auto"
			@close="close" v-loading="dataLoading">
			<div class="drawer-content">
				<template v-if="codeData">
					<h2 class="name">{{codeData.name}}</h2>
					<div class="code">
						<vue-qr :logoSrc="logo" :text="codeData.qrCodeUrl" :size="800" :logoMargin="8"
							logoBackgroundColor="#ffffff" :callback="getImage" :margin="0" :correctLevel="3" ></vue-qr>
						<input class="copyTool" ref="copyTool" :value="codeData.copyUrl" />
					</div>
					<div class="MT10">
						<el-button size="small" plain type="primary"
							@click="$refs.H5Preview.show(codeData.qrCodeUrl)">直接打开</el-button>
						<el-button type="primary" size="small" @click="copy">复制链接</el-button>
						<el-button type="primary" size="small" @click="downloadCode">下载二维码</el-button>
					</div>
					<template v-if="codeData.tourId">						
						<div class="textCenter MT20">{{codeData.tourName}}</div>
						<div class="code">
							<vue-qr :logoSrc="logo" :text="xunyanUrl" :size="800" :logoMargin="8" logoBackgroundColor="#ffffff" :callback="getImage2" :margin="0" ></vue-qr>
							<input class="copyTool" ref="copyTool3" :value="xunyanUrl" />
						</div>
						<div class="MT10 textCenter">
							<el-button size="small" plain type="primary"
								@click="$refs.H5Preview.show(xunyanUrl)">直接打开</el-button>
							<el-button type="primary" size="small" @click="copyXunyan">复制链接</el-button>
							<el-button type="primary" size="small" @click="downloadCodeXunyan">下载二维码</el-button>
						</div>
					</template>
					
					
					
					
					<div class="MT30 MB20" v-if="codeData && codeData.poster">
						<p class="MB10">生成wap购票推广图片</p>
						<div>
							<el-button type="primary" size="small" @click="BuildPic(1)">生成独家总代</el-button>
							<el-button type="primary" size="small" @click="BuildPic(2)">生成官方代理</el-button>
							<el-button type="primary" size="small" @click="BuildPic(3)">生成官方总代</el-button>
						</div>
					</div>
					<div class="code MT30" v-if="codeData.wechatCodeUrl">
						<img :src="codeData.wechatCodeUrl" class="img2" ref="img2" @load="handleLoad">
						<input class="copyTool" ref="copyTool" :value="codeData.copyUrl" />
					</div>
					<div class="MT10" v-if="codeData.wechatCodeUrl">
						<el-button type="primary" size="small"
							@click="downloadCodeWechat(codeData.wechatCodeUrl)">下载二维码</el-button>
					</div>
					<div class="MT30 MB20" v-if="codeData && codeData.poster && codeData.wechatCodeUrl && wechatcodeShow ">
						<p class="MB10">生成小程序购票推广图片</p>
						<div>
							<el-button type="primary" size="small" @click="BuildPic(4)">生成独家总代</el-button>
							<el-button type="primary" size="small" @click="BuildPic(5)">生成官方代理</el-button>
							<el-button type="primary" size="small" @click="BuildPic(6)">生成官方总代</el-button>
						</div>
					</div>
					<template v-if="codeData.redbookLink">
						<div class="MT30">
							<h2 class="name">小红书分享链接</h2>
							<div class="code">
								<vue-qr :text="codeData.redbookLink" :size="800" :logoMargin="8"
									logoBackgroundColor="#ffffff" :callback="getImage" :margin="0"></vue-qr>
								<input class="copyTool2" ref="copyTool2" :value="codeData.redbookLink" />
							</div>
							<div class="color-success MT10 MB20"> {{codeData.redbookLink}} </div>
							<el-button type="primary" size="small" @click="copy2">复制链接</el-button>
						</div>
					</template>
					<!-- 生成图片  -->
					<div ref="buildPic" class="canvasMain">
						<div class="posterBox">
							<el-image :src="codeData.poster | coverImage(1080,1440)" fit="cover"></el-image>
						</div>
						<div class="canvasFooter">
							<div id="pictypeMain">
								<el-image :src="dujia" class="imgSize" v-if="picType == 1 || picType == 4" ></el-image>
								<el-image :src="guanfang" class="imgSize" v-if="picType == 2 || picType == 5"></el-image>
								<el-image :src="zongdai" class="imgSize" v-if="picType == 3 || picType == 6"></el-image>
							</div>
							<div class="codeMain">
								<div class="imgQr">
									<el-image :src="codeImage" class="codeImage"
										v-if="picType == 1 || picType == 2 || picType == 3"></el-image>
									<img :src="codeData.wechatCodeUrl" class="footImgcode"
										v-if="picType == 4 || picType == 5 || picType == 6">
								</div>
								<div class="footText">
									<el-image :src="buytext"></el-image>
								</div>
							</div>
						</div>
					</div>

					<template v-if="codeData.shortLink">
						<div class="MT30">
							<h2 class="name">微信小程序短链接</h2>
							<input class="copyTool" ref="copyTool4" :value="codeData.shortLink" />
							<div class="color-success MT10 MB20"> {{ codeData.shortLink }} </div>
							<el-button type="primary" size="small" @click="copy4">复制链接</el-button>
						</div>
					</template>
				</template>
			</div>
			<div class="drawer-footer">
				<el-button @click="close">关闭</el-button>
			</div>
		</el-drawer>
		<H5Preview ref="H5Preview"></H5Preview>
	</div>
</template>

<script>
	import VueQr from 'vue-qr';
	import logo from '@/assets/img/logo.png';
	import zongdai from '@/assets/img/zongdai.png';
	import dujia from '@/assets/img/dujia.png';
	import guanfang from '@/assets/img/guanfang.png';
	import buytext from '@/assets/img/buytext.png';
	import H5Preview from '@/components/H5Preview';
	import html2canvas from 'html2canvas';
	export default {
		components: {
			VueQr,
			H5Preview
		},
		data() {
			return {
				drawerShow: false,
				codeData: null,
				logo: logo,
				zongdai: zongdai,
				dujia: dujia,
				guanfang: guanfang,
				buytext: buytext,
				codeImage: '',
				copyTimer: null,
				copyTimer2: null,
				copyTimer3:null,
				sswap: process.env.VUE_APP_SSWAP_URL,
				wechatcodeLoading: false,
				wechatcodeShow:false,
				imageSrc: '',
				dataLoading: false,
				picType: 1,
				picName: '',
				//是否展示小程序码,0是展示，1是展示
				xunyanUrl:'',
				codeImage2:'',
			}
		},
		methods: {
			close() {
				this.drawerShow = false
			},
			show(obj) {
				
				this.codeData = {
					...obj,
					name: obj.name || obj.title,
					copyUrl: obj.qrCodeUrl,
					wechatCodeUrl: obj.wechatCodeUrl || '',
					redbookLink: obj.redBookUrl || obj.Link,
					activityId: obj.id,
					shortLink: obj.shortLink || '',
				};
				// this.codeData.qrCodeUrl += this.codeData.qrCodeUrl.includes('?') ? "&" : "?";
				// this.codeData.qrCodeUrl += "previewFrom=admin"

				this.drawerShow = true
				if (!this.codeData.wechatCodeUrl && this.codeData.showWechart == 1) {
					this.getWechatcode()
				}
				if( this.codeData && this.codeData.tourId ){
					this.xunyanUrl = this.sswap +'/pages/activity/list/list?type=1&tag='+ this.codeData.tourId
				}

			},
			handleLoad(){
				this.wechatcodeShow = true
			},
			//wap独家总代
			async BuildPic(type) {				
				this.dataLoading = true				
				this.picType = type
				if( this.wechatcodeShow ){
					if (this.picType == 1 || this.picType == 4) {
						this.picName = '独家总代'
					}
					if (this.picType == 2 || this.picType == 5) {
						this.picName = '官方代理'
					}
					if (this.picType == 3 || this.picType == 6) {
						this.picName = '官方总代'
					}
					const element = this.$refs.buildPic;
					
					setTimeout(async () => {						
						// 使用 html2canvas 将节点转换为 canvas
						const canvas = await html2canvas(element, {
							scale: 2, // 可选：调整生成图像的分辨率
							logging: true, // 可选：启用日志记录
							useCORS: true, // 可选：允许跨域请求

						});
						this.imageSrc = canvas.toDataURL('image/jpg');
						if (this.imageSrc != '') {
							
							// 创建一个隐藏的 <a> 元素
							const link = document.createElement('a');
							link.href = this.imageSrc;
							link.download = this.codeData.activityId + this.picName + '.png'; // 设置下载文件的名称
							// 触发点击事件
							document.body.appendChild(link);
							link.click();
							// 移除 <a> 元素
							document.body.removeChild(link);
							
						}
						this.imageSrc = ''
						this.dataLoading = false
					}, 1000)					
						
				}
						
			},

			getImage(url) {
				this.codeImage = url;
			},
			getImage2(url){
			    this.codeImage2 = url;
			},
			downloadCode() {
				const _data = this.$utils.base64ToBlob(this.codeImage);
				this.$utils.exportFile(_data, `${this.codeData.name}的二维码.png`);
			},
			downloadCodeWechat(imgUrl) {
				const url = imgUrl
				const fileName = this.codeData.name + '-小程序码.jpg'
				this.$utils.downloadImg(url, fileName);
			},
			copyXunyan(){
				clearTimeout(this.copyTimer3);
				this.copyTimer3 = setTimeout(() => {
				    const e = this.$refs.copyTool3;
				    e.select();
				    document.execCommand("Copy"); // 执行浏览器复制命令
				    this.$message.success("链接已复制，可粘贴");
				},300)
			},
			downloadCodeXunyan(){
			    const _data = this.$utils.base64ToBlob(this.codeImage2);
			    this.$utils.exportFile(_data,`${this.codeData.tourName}的巡演二维码.png`);
			},
			getWechatcode() {
				this.wechatcodeLoading = true
				this.$request({
					url: "/activity/getWeChatMiniQrCode",
					method: "post",
					params: {
						activityId: this.codeData.activityId
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.wechatcodeLoading = false
						this.codeData.wechatCodeUrl = result?.codeUrl || ''
						this.codeData.shortLink = result?.shortLink || ''
					}
				})
			},
			//复制链接
			copy() {
				clearTimeout(this.copyTimer);
				this.copyTimer = setTimeout(() => {
					const e = this.$refs.copyTool;
					e.select();
					document.execCommand("Copy"); // 执行浏览器复制命令
					this.$message.success("已复制成功，可粘贴");
				}, 300)
			},
			//复制小红书分享链接
			copy2() {
				clearTimeout(this.copyTimer);
				this.copyTimer2 = setTimeout(() => {
					const e = this.$refs.copyTool2;
					e.select();
					document.execCommand("Copy"); // 执行浏览器复制命令
					this.$message.success("已复制成功，可粘贴");
				}, 300)
			},
			//复制微信小程序短链接
			copy4() {
				clearTimeout(this.copyTimer4);
				this.copyTimer4 = setTimeout(() => {
					const e = this.$refs.copyTool4;
					e.select();
					document.execCommand("Copy"); // 执行浏览器复制命令
					this.$message.success("已复制成功，可粘贴");
				}, 300)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.drawer-content {
		text-align: center;

		.name {
			font-size: 14px;
			line-height: 20px;
		}

		.code {
			width: 200px;
			height: 200px;
			margin: 15px auto;

			img {
				width: 100%;
				max-width: 100%;
			}
		}
	}

	.copyTool,
	.copyTool2 {
		opacity: 0;
		filter: alpha(opacity=0);
		// height: 1px;
	}

	.posterBox {
		width: 540px;
		height: 720px;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;

		.el-image {
			max-width: 100%;
			max-height: 100%;
		}
	}

	.canvasMain {
		width: 540px;
		position: absolute;
		left: -9999px;
	}

	.canvasFooter {
		width: 540px;
		padding: 11px 18px 15px 18px;
		background: #fff;
		display: flex;
		justify-content: space-between;
	}

	.imgSize {
		height: 75px;
		width: 423px;
	}

	.codeMain {
		width: 64px;
		height: 80px;
		background: #ff3342;
		border-radius: 4px;

		.imgQr {
			background: #fff;
			margin: 2px 0 0 2px;
			width: 60px;
			height: 60px;

			.el-image {
				margin-top: 3px;
				width: 55px;
				height: 55px;
			}
		}

		.footImgcode {
			margin-top: 3px;
			max-width: 58px;
			max-height: 58px;
		}

		.footText {
			width: 64px;
			height: auto;

			.el-image {
				margin: 5px auto 0 auto;
				width: 39px;
				height: 8px;
				display: block;
			}
		}

	}
</style>